import React from "react";
import { Icon } from "../../../ui/Icon.js";
import { Toolbar } from "../../../ui/Toolbar.js";
import * as Popover from "@radix-ui/react-popover";
import { LinkEditorPanel } from "../../../panels/index.js";
import { Link } from "lucide-react";
import i18next from "i18next";

export type EditLinkPopoverProps = {
  onSetLink: (link: string, openInNewTab?: boolean) => void;
};

export const EditLinkPopover = ({ onSetLink }: EditLinkPopoverProps) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Toolbar.Button type="button"
          tooltip={i18next.t("setLink") || "Set Link"}
        >
          <Icon icon={Link} />
        </Toolbar.Button>
      </Popover.Trigger>
      <Popover.Content>
        <LinkEditorPanel onSetLink={onSetLink} />
      </Popover.Content>
    </Popover.Root>
  );
};
